import DialogRecherchePersonneMorale from './DialogRecherchePersonneMorale';
import DialogCreationPersonneMorale from './DialogCreationPersonneMorale';

export default {
  install(Vue) {
    Vue.component(
      'dialogRecherchePersonneMorale',
      DialogRecherchePersonneMorale,
    );
    Vue.component('dialogCreationPersonneMorale', DialogCreationPersonneMorale);
  },
};
